var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"group"}},[_c('h4',[_vm._v("2018年\"北汽集团\"杯北京市中小学生校级冰球联赛")]),_vm._v(" "),_c('div',[_c('h5',[_vm._v("请选择赛事组别")]),_vm._v(" "),_c('van-search',{attrs:{"placeholder":"请输入搜索关键词"}}),_vm._v(" "),_c('h5',[_vm._v("请选择参赛球队")]),_vm._v(" "),_c('van-search',{attrs:{"placeholder":"请输入搜索关键词"}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-931b28e2","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ucenter/select-group.vue
// module id = null
// module chunks = 